// Port of api/fuel/app/classes/filter/core/data.php
// JS note:
// - folder routing in this file is JS-only bootstrap glue
// - returned data keys should remain driven by the PHP type data classes
import F from 'offline/filter/constants'
import Util from 'offline/util'

var Data = {
	run: function(config, filter, packageItems, data) {
		var folder = F.TYPE_FOLDER[config.filterType]
		if (folder === 'games') {
			var GamesData = require('offline/filter/data/games').default
			return Util.array_merge_recursive_distinct(data || {}, GamesData.run(config, filter, packageItems, data || {}))
		}
		if (folder === 'users') {
			var UsersData = require('offline/filter/data/users').default
			return Util.array_merge_recursive_distinct(data || {}, UsersData.run(config, filter, packageItems, data || {}))
		}
		if (folder === 'lists') {
			var ListsData = require('offline/filter/data/lists').default
			return Util.array_merge_recursive_distinct(data || {}, ListsData.run(config, filter, packageItems, data || {}))
		}
		return data || {}
	}
}

export default Data
